<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import { createRealEstateBrokerCommissionPresenter } from '../composables/realEstateBrokerCommissionPresenter';

defineProps({
  detail: { type: Object, required: true },
});

const { t } = useI18n();
const {
  address,
  addressDetail,
  installmentLabel,
  money,
  paymentForecast,
  percentage,
  statusLabel,
} = createRealEstateBrokerCommissionPresenter(t);
</script>

<template>
  <LaisCard density="flush">
    <div
      class="grid gap-5 p-5 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-start"
    >
      <div class="min-w-0 space-y-3">
        <div class="flex flex-wrap items-center gap-2">
          <span
            class="rounded-full bg-lais-primary-50 px-2.5 py-1 text-xs font-semibold text-lais-primary"
          >
            {{ statusLabel(detail) }}
          </span>
          <span class="text-sm text-lais-text-muted">
            {{ installmentLabel(detail) }}
          </span>
        </div>
        <div class="flex min-w-0 gap-3">
          <span
            class="i-lucide-map-pin mt-0.5 size-5 shrink-0 text-lais-primary"
            aria-hidden="true"
          />
          <div class="min-w-0">
            <h2
              class="truncate font-redHatDisplay text-xl font-semibold text-lais-text"
            >
              {{ address(detail) }}
            </h2>
            <p
              v-if="addressDetail(detail)"
              class="mt-1 text-sm text-lais-text-muted"
            >
              {{ addressDetail(detail) }}
            </p>
          </div>
        </div>
        <dl class="grid gap-3 text-sm sm:grid-cols-3">
          <div>
            <dt class="text-lais-text-muted">
              {{ t('REAL_ESTATE_BROKER_COMMISSION.HERO.SALE_VALUE') }}
            </dt>
            <dd class="mt-1 font-semibold text-lais-text">
              {{
                detail.processo?.valor_venda ||
                t('REAL_ESTATE_BROKER_COMMISSION.TABLE.NOT_INFORMED')
              }}
            </dd>
          </div>
          <div>
            <dt class="text-lais-text-muted">
              {{ t('REAL_ESTATE_BROKER_COMMISSION.HERO.SIGNATURE_DATE') }}
            </dt>
            <dd class="mt-1 font-semibold text-lais-text">
              {{
                detail.processo?.data_assinatura ||
                t('REAL_ESTATE_BROKER_COMMISSION.TABLE.NOT_INFORMED')
              }}
            </dd>
          </div>
          <div>
            <dt class="text-lais-text-muted">
              {{ t('REAL_ESTATE_BROKER_COMMISSION.HERO.DEED_FORECAST') }}
            </dt>
            <dd class="mt-1 font-semibold text-lais-text">
              {{
                detail.processo?.previsao_escritura ||
                t('REAL_ESTATE_BROKER_COMMISSION.TABLE.NOT_INFORMED')
              }}
            </dd>
          </div>
        </dl>
      </div>
      <div
        class="rounded-lais border border-lais-border-soft bg-lais-bg-soft p-4 lg:min-w-64"
      >
        <p class="text-sm font-semibold text-lais-text-muted">
          {{ t('REAL_ESTATE_BROKER_COMMISSION.HERO.OWN_VALUE') }}
        </p>
        <p class="mt-2 font-redHatDisplay text-2xl font-bold text-lais-text">
          {{ money(detail.valor_proprio) }}
        </p>
        <p class="mt-1 text-sm text-lais-text-body">
          {{ percentage(detail.porcentagem_propria) }}
        </p>
        <p class="mt-4 text-xs text-lais-text-muted">
          {{ paymentForecast(detail.parcela?.previsao_pagamento) }}
        </p>
      </div>
    </div>
  </LaisCard>
</template>
